import { arrayEqual } from 'services/utils';

import { useReduxSelector } from './redux';

export const useSectorsNoWork = () => {
  const sectors = useReduxSelector((redux) => redux.app.sectors, arrayEqual);

  return sectors.filter((sector) => !sector.isNoWork);
};
